The time that the reason was generated.
